import { loginManager } from "@/services/security/login-manager";

class StringManager {
  toCamelCase(str) {
    return str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("-", "").replace("_", ""));
  }

  capitalize(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  gender(alias) {
    let ret = 1;
    const female = [
      "subject",
      "component",
      "help-document",
      "unit",
      "skill-category",
      "category",
      "skill",
      "news",
      "training-course",
      "training",
      "absence",
      "skill-session",
      "document-category",
    ];

    const unique = ["data-agreement"];

    if (female.includes(alias)) {
      ret = 2;
    } else if (unique.includes(alias)) {
      ret = 0;
    }

    return ret;
  }

  processGlobalContent(text) {
    const apiPath = loginManager.getApiPath().slice(0, -4);
    const regLink = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g;
    const regImg = /<img\s+(?:[^>]*?\s+)?src="([^"]*)"/g;

    let newtext = text.replaceAll(regImg, function (match, p1) {
      const addDomain = p1.includes("/uploads/news/editor") && !p1.includes(apiPath);
      return '<img src="' + (addDomain ? apiPath : "") + p1 + '"';
    });

    newtext = newtext.replaceAll(regLink, function (match, p1) {
      const addDomain = p1.includes("/uploads/news/editor") && !p1.includes(apiPath);
      return '<a href="' + (addDomain ? apiPath : "") + p1 + '"';
    });

    return newtext;
  }
}

export const stringManager = new StringManager();
